"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconReload = void 0;
var React = __importStar(require("react"));
var IconReload = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M21.875,10.4141 C21.958,10.9361 22,11.4711 22,12.0001 C22,17.5141 17.514,22.0001 12,22.0001 C9.593,22.0001 7.332,21.1621 5.529,19.6241 L4.586,20.5671 C4.49,20.6631 4.362,20.7141 4.232,20.7141 C4.175,20.7141 4.116,20.7041 4.06,20.6841 C3.877,20.6161 3.75,20.4481 3.734,20.2541 L3.501,17.3571 C3.489,17.2111 3.542,17.0671 3.646,16.9641 C3.749,16.8601 3.896,16.8101 4.039,16.8191 L6.936,17.0521 C7.13,17.0671 7.297,17.1941 7.364,17.3771 C7.432,17.5601 7.387,17.7661 7.249,17.9031 L6.241,18.9111 C7.854,20.2621 9.861,21.0001 12,21.0001 C16.963,21.0001 21,16.9631 21,12.0001 C21,11.5221 20.962,11.0421 20.887,10.5701 C20.844,10.2981 21.029,10.0421 21.303,9.9981 C21.569,9.9561 21.831,10.1411 21.875,10.4141 Z M12,3 C7.037,3 3,7.037 3,12 C3,12.476 3.037,12.951 3.111,13.416 C3.154,13.688 2.968,13.944 2.695,13.988 C2.669,13.992 2.643,13.994 2.616,13.994 C2.375,13.994 2.162,13.818 2.123,13.572 C2.042,13.057 2,12.527 2,12 C2,6.486 6.486,2 12,2 C14.479,2 16.816,2.907 18.652,4.549 L19.477,3.724 C19.615,3.586 19.819,3.539 20.003,3.608 C20.186,3.675 20.313,3.843 20.328,4.037 L20.562,6.934 C20.573,7.079 20.521,7.224 20.417,7.327 C20.323,7.421 20.195,7.474 20.063,7.474 C20.05,7.474 20.037,7.473 20.023,7.472 L17.127,7.239 C16.933,7.224 16.766,7.097 16.698,6.914 C16.631,6.731 16.676,6.525 16.813,6.388 L17.945,5.256 C16.3,3.803 14.213,3 12,3 Z" }))); };
exports.IconReload = IconReload;
exports.IconReload.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconReload;
